module.exports = __webpack_public_path__ + "static/media/menuIcon.ae6a8903.svg";